export const enumAgendamentosIcons = [
    {
      value: 'EmElaboracao',
      message: 'Em Elaboração',
      icon: 'fileClockOutline',
      cor: 'warning'
    },
    {
      value: 'AguardandoAnaliseTecnica',
      message: 'Aguardando Análise Técnica',
      icon: 'clipboardEditOutline',
      cor: 'warning'
    },
    {
      value: 'AguardandoOrcamento',
      message: 'Aguardando Orçamento',
      icon: 'fileDocumentAlertOutline',
      cor: 'black'
    },
    {
      value: 'AguardandoAprovacaoOrcamento',
      message: 'Aguardando Aprovação do Orçamento',
      icon: 'currencyUsd',
      cor: 'black'
    },
    {
      value: 'AguardandoProgramacao',
      message: 'Aguardando Programação',
      icon: 'clockOutline',
      cor: '#87c8e0'
    },
    {
      value: 'AguardandoConfirmacao',
      message: 'Aguardando Confirmação',
      icon: 'clipboardTextOutline',
      cor: 'purple'
    },
    {
      value: 'Programado',
      message: 'Programado',
      icon: 'numeric1CircleOutline',
      cor: 'primary'
    },
    {
      value: 'EmExecucao',
      message: 'Em Execução',
      icon: 'numeric2CircleOutline',
      cor: 'primary'
    },
    {
      value: 'AguardandoAnaliseCritica',
      message: 'Aguardando Análise Crítica',
      icon: 'numeric3CircleOutline',
      cor: 'primary'
    },
    {
      value: 'Concluido',
      message: 'Concluído',
      icon: 'checkDecagramOutline',
      cor: 'success'
    },
    {
      value: 'ReprovadoPeloOrcamento',
      message: 'Reprovado Pelo Orçamento',
      icon: 'currencyUsdOff',
      cor: 'danger'
    },
    {
      value: 'Cancelado',
      message: 'Cancelado',
      icon: 'closeCircleOutline',
      cor: 'danger'
    },
  ];
  